export const theme = {
  fonts: {
    montserrat: "'Montserrat', sans-serif",
    cardo: "'Cardo', serif",
  },
  backgroundColor: {
    dark: "#0d0e0e",
    light: "#ffffff",
    orange: "#e64e04",
    darkGray: "#111",
  },
  color: {
    dark: "#000000",
    darkGray: "#262637",
    lightGray: "#aaa",
    light: "#fff",
    secondaryLight: "#f1f1f1",
    tertiaryLight: "#d3d3d3",
    link: "#4353ff",
  },
  CTA: {
    primary: "#e64e04",
    secondary: "#4353ff",
  },
  breakpoints: {
    lg: "64rem",
    md: "58.125rem",
    sm: "48rem",
    xs: "31.25rem",
  },
};
